import React from 'react';

import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../../common/input/modal/Modal';
import logoimg from '../../../assets/images/logo.png';

const PostJobModalView = (props) => {
    return (
        <>
            <Modal className="price-calculator-popup" show={props.post_modal_show} onHide={props.hidePostJobModal}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header">
                                        <h4>Alert !!</h4>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div style={{textAlign:"center",padding:'20px'}} className="red-price-box">
                                            <h4 style={{color:'white'}}>Do you Want To post a Job ?</h4>
                                            <a href='/registrations/individual/form1'><button style={{background: '#8cd50b', margin : '11px'}} type="button" className="btn btn-red regular">Continue as Private <i className="fa fa-user" aria-hidden="true"></i></button></a>
                                            <a href='/registrations/council/form1'><button style={{background: '#8cd50b'}}  type="button" className="btn btn-red regular">Continue as Council <i className="fa fa-suitcase" aria-hidden="true"></i></button></a>

                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default PostJobModalView;